/**
 * 글자 크기 — 옛 Navigation 사용자 메뉴의 로직을 «그대로» 옮긴 단일 출처(⑭ R14a).
 * localStorage kd_font_size + <html class="font-{small|medium|large}"> + (로그인 시) profiles.font_size_preference.
 * ⛔ 쿠키·서버 분기 없음 — 수화 뒤 브라우저에서만 적용한다(서버 HTML 은 방문자 무관).
 */

export const FONT_SIZES = ['small', 'medium', 'large'] as const;
export type FontSize = (typeof FONT_SIZES)[number];
export const FONT_SIZE_LABEL: Record<FontSize, string> = { small: '작게', medium: '보통', large: '크게' };
export const FONT_KEY = 'kd_font_size';

export function isFontSize(v: unknown): v is FontSize {
  return typeof v === 'string' && (FONT_SIZES as readonly string[]).includes(v);
}

export function applyFontClass(val: FontSize): void {
  const el = document.documentElement;
  el.classList.remove('font-small', 'font-medium', 'font-large');
  el.classList.add(`font-${val}`);
}

export function readSavedFont(): FontSize | null {
  try {
    const v = localStorage.getItem(FONT_KEY);
    return isFontSize(v) ? v : null;
  } catch {
    return null;
  }
}

export function saveFont(val: FontSize): void {
  try { localStorage.setItem(FONT_KEY, val); } catch { /* 저장소 막힘 — 이번 화면만 적용 */ }
  applyFontClass(val);
  // 로그인 사용자면 프로필 선호도 저장(옛 Navigation 과 같은 열). supabase 클라이언트는 누를 때만 불러온다 —
  // /more 첫 로드 번들에 싣지 않는다(빌드 실측 +57kB).
  import('@/lib/supabase-browser').then(async ({ createSupabaseBrowser }) => {
    const sb = createSupabaseBrowser();
    const { data } = await sb.auth.getSession();
    const uid = data.session?.user?.id;
    if (uid) await sb.from('profiles').update({ font_size_preference: val }).eq('id', uid);
  }).catch(() => {});
}
